import React, { ComponentProps, FC } from "react";

/* This generic component is intentionally very plain. This will be added onto with necessary
 * styles and functionality for use in the WebPlusAds component as development continues.
 */

const Container: FC<ComponentProps<"div">> = ({
  className,
  children,
  ...rest
}) => {
  return <div className={className} {...rest} data-sentry-component="Container" data-sentry-source-file="index.tsx">
      {children}
    </div>;
};
export default Container;